<template>
    <div>
        <p class="sr-only" role="status" aria-atomic="true">{{ copied ? copiedText : "" }}</p>
        <div class="request-action">
            <div class="request-action-state" :class="{ 'opacity-0': !copied }" :inert="!copied">
                <StatusChip state="done" :size="size" class="w-full justify-center gap-2">
                    <template #leading><i class="bi bi-check-lg text-lg/none" aria-hidden="true"></i></template>
                    {{ copiedText }}
                    <template v-if="!hideDismiss" #trailing>
                        <BaseButton theme="tertiary" size="sm" icon-only :aria-label="t('connections.publicProfileRequestLink.dismissLabel')" @click="emit('dismiss')">
                            <i class="bi bi-x-lg leading-none" aria-hidden="true" />
                        </BaseButton>
                    </template>
                </StatusChip>
            </div>
            <div class="request-action-state" :class="{ 'opacity-0': copied }" :inert="copied">
                <BaseButton :theme="theme" :size="size" class="shrink-0 gap-2 w-full" :disabled="disabled" @click="emit('copy')">
                    <i v-if="theme === 'tertiary'" class="bi bi-link-45deg" aria-hidden="true"></i>
                    {{ t("connections.publicProfileRequestLink.copyButton") }}
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import StatusChip from "~vue/components/StatusChip.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = withDefaults(
    defineProps<{
        copied: boolean;
        disabled?: boolean;
        hideDismiss?: boolean;
        size?: "sm" | "md";
        linkCopiedText?: string;
        /** `neutral` is an outlined button without the link icon. */
        theme?: "tertiary" | "neutral";
    }>(),
    {
        disabled: false,
        hideDismiss: false,
        size: "md",
        linkCopiedText: undefined,
        theme: "tertiary",
    },
);

const copiedText = computed(() => props.linkCopiedText ?? t("connections.publicProfileRequestLink.linkCopied"));

const emit = defineEmits<{
    copy: [];
    dismiss: [];
}>();
</script>

<style scoped>
@reference "../../../css/tailwind.css";
@layer components {
    .request-action {
        @apply grid;
    }
    .request-action-state {
        @apply col-start-1 row-start-1 self-center transition-opacity duration-150 motion-reduce:transition-none;
    }
}
</style>
